import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-40195103"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "role-permission-container"
};
const _hoisted_2 = {
  class: "role-list-panel"
};
const _hoisted_3 = {
  class: "search-box"
};
const _hoisted_4 = {
  class: "role-list"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "role-name"
};
const _hoisted_7 = {
  class: "permission-panel"
};
const _hoisted_8 = {
  class: "panel-header"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "功能权限", -1));
const _hoisted_10 = {
  class: "header-right"
};
const _hoisted_11 = {
  key: 0,
  class: "permission-content"
};
const _hoisted_12 = {
  class: "group-title"
};
const _hoisted_13 = {
  class: "permission-items"
};
const _hoisted_14 = {
  key: 1,
  class: "empty-placeholder"
};
import { ref, reactive, onMounted } from 'vue';
import { message } from 'ant-design-vue';
import { LockOutlined } from '@ant-design/icons-vue';
import { getRoleList, editRolePerms } from '@/api/permission';
import { getResourceList } from '@/api/menuMangeApi';
import PermissionTree from '@/components/PermissionTree.vue';
// 编辑模式状态
export default /*#__PURE__*/_defineComponent({
  __name: 'rolePermission',
  setup(__props) {
    const isEditMode = ref(false);
    // 角色列表
    const roleList = ref([]);
    const currentRole = ref(null);
    const searchKeyword = ref('');
    const permissionName = ref('');
    const loading = ref(false);
    const savingLoading = ref(false);
    // 权限相关
    const permissionGroups = ref([]);
    const selectedPermissions = reactive({});
    const resourceList = ref([]);
    // 获取角色列表
    const fetchRoleList = async () => {
      try {
        loading.value = true;
        const {
          code,
          pageRoleInfo
        } = await getRoleList({
          currentPage: 1,
          pageSize: 2000,
          condition: searchKeyword.value
        });
        if (code === '0000') {
          roleList.value = pageRoleInfo;
          // 如果有角色且当前未选择角色，则自动选择第一个
          if (roleList.value.length > 0 && !currentRole.value) {
            selectRole(roleList.value[0]);
          }
        }
      } catch (error) {
        console.error('获取角色列表失败', error);
      } finally {
        loading.value = false;
      }
    };
    // 获取权限资源列表
    const fetchResourceList = async () => {
      try {
        const {
          code,
          data
        } = await getResourceList();
        if (code === '0' && data) {
          resourceList.value = data;
          initPermissionGroups();
        }
      } catch (error) {
        console.error('获取权限资源列表失败', error);
      }
    };
    // 搜索角色
    const handleSearch = () => {
      fetchRoleList();
    };
    // 选择角色
    const selectRole = role => {
      currentRole.value = role;
      permissionName.value = role.roleName || '';
      initPermissions();
    };
    // 初始化权限数据
    const initPermissions = () => {
      // 清空已选权限
      Object.keys(selectedPermissions).forEach(key => {
        selectedPermissions[key] = false;
      });
      // 设置当前角色已有的权限
      if (currentRole.value && currentRole.value.permId) {
        const permIds = currentRole.value.permId.split(',');
        permIds.forEach(id => {
          selectedPermissions[id] = true;
        });
      }
    };
    // 初始化权限分组
    const initPermissionGroups = () => {
      if (!resourceList.value || resourceList.value.length === 0) return;
      // 直接使用API返回的树形结构
      permissionGroups.value = resourceList.value.map(item => ({
        key: item.id,
        title: item.name,
        permissionId: item.permissionId,
        permission: item.permission,
        items: item.children || []
      }));
      permissionGroups.value = permissionGroups.value.filter(item => {
        var _item$items;
        return (_item$items = item.items) === null || _item$items === void 0 ? void 0 : _item$items.length;
      }).map(item => {
        return {
          ...item,
          items: item.items.map(e => {
            return {
              ...e,
              children: e.children.length > 0 ? e.children : e.resType === 2 ? [{
                ...e
              }] : []
            };
          })
        };
      });
      // 递归初始化所有权限的选中状态
      const initAllPermissions = resources => {
        if (!resources || resources.length === 0) return;
        resources.forEach(resource => {
          // 使用permissionId作为唯一标识符
          selectedPermissions[resource.permissionId] = false;
          // 递归处理子权限
          if (resource.children && resource.children.length > 0) {
            initAllPermissions(resource.children);
          }
        });
      };
      // 初始化所有权限的选中状态
      initAllPermissions(resourceList.value);
    };
    // 检查组是否部分选中
    const isIndeterminate = groupKey => {
      const group = permissionGroups.value.find(g => g.key === groupKey);
      if (!group) return false;
      // 获取组内所有权限ID（包括子权限）
      const allPermIds = getAllPermissionIds(group.items);
      if (allPermIds.length === 0) return false;
      const checkedCount = allPermIds.filter(id => selectedPermissions[id]).length;
      return checkedCount > 0 && checkedCount < allPermIds.length;
    };
    // 检查组是否全选
    const isGroupChecked = groupKey => {
      const group = permissionGroups.value.find(g => g.key === groupKey);
      if (!group) return false;
      // 获取组内所有权限ID（包括子权限）
      const allPermIds = getAllPermissionIds(group.items);
      if (allPermIds.length === 0) return false;
      return allPermIds.every(id => selectedPermissions[id]);
    };
    // 递归获取所有权限ID
    const getAllPermissionIds = resources => {
      if (!resources || resources.length === 0) return [];
      let result = [];
      resources.forEach(resource => {
        // 添加当前资源的权限ID
        result.push(resource.permissionId);
        // 递归添加子资源的权限ID
        if (resource.children && resource.children.length > 0) {
          result = result.concat(getAllPermissionIds(resource.children));
        }
      });
      return result;
    };
    // 组选择变化
    const onGroupCheckChange = (groupKey, e) => {
      const checked = e.target.checked;
      const group = permissionGroups.value.find(g => g.key === groupKey);
      if (!group) return;
      // 递归设置组内所有权限的选中状态
      setResourceChecked(group.items, checked);
      // 额外选中组本身的权限
      if (group.permissionId) {
        selectedPermissions[group.permissionId] = checked;
      }
    };
    // 递归设置资源的选中状态
    const setResourceChecked = (resources, checked) => {
      if (!resources || resources.length === 0) return;
      resources.forEach(resource => {
        // 设置当前资源的选中状态
        if (resource.permissionId) {
          selectedPermissions[resource.permissionId] = checked;
        }
        // 递归设置子资源的选中状态
        if (resource.children && resource.children.length > 0) {
          setResourceChecked(resource.children, checked);
        }
      });
    };
    // 处理权限变化事件
    const handlePermissionChange = data => {
      if (data && data.permissionId) {
        selectedPermissions[data.permissionId] = data.checked;
      }
    };
    // 处理级联权限变化事件（批量更新多个权限）
    const handleCascadePermissionChange = updateItems => {
      if (!updateItems || updateItems.length === 0) return;
      // 批量更新所有权限状态
      updateItems.forEach(item => {
        if (item && item.permissionId) {
          selectedPermissions[item.permissionId] = item.checked;
        }
      });
    };
    // 进入编辑模式
    const enterEditMode = () => {
      isEditMode.value = true;
    };
    // 取消编辑模式
    const cancelEdit = () => {
      isEditMode.value = false;
    };
    // 保存权限
    const savePermissions = async () => {
      if (!currentRole.value) {
        message.warning('请先选择角色');
        return;
      }
      // 收集已选权限ID
      const selectedPermIds = Object.keys(selectedPermissions).filter(id => selectedPermissions[id]);
      try {
        savingLoading.value = true;
        const {
          code
        } = await editRolePerms({
          rid: currentRole.value.id,
          pid: selectedPermIds.join(',')
        });
        if (code === '0000') {
          message.success('权限保存成功');
          // 刷新角色列表，获取最新权限信息
          fetchRoleList();
          // 退出编辑模式
          isEditMode.value = false;
        }
      } catch (error) {
        console.error('保存权限失败', error);
        message.error('保存权限失败');
      } finally {
        savingLoading.value = false;
      }
    };
    onMounted(async () => {
      // 获取权限资源列表
      await fetchResourceList();
      // 获取角色列表
      await fetchRoleList();
    });
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_empty = _resolveComponent("a-empty");
      const _component_a_spin = _resolveComponent("a-spin");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_checkbox = _resolveComponent("a-checkbox");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_a_input, {
        placeholder: "输入角色名称",
        value: searchKeyword.value,
        "onUpdate:value": _cache[0] || (_cache[0] = $event => searchKeyword.value = $event),
        onPressEnter: handleSearch
      }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_a_spin, {
        spinning: loading.value
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roleList.value, role => {
          var _currentRole$value;
          return _openBlock(), _createElementBlock("div", {
            key: role.id,
            class: _normalizeClass(["role-item", {
              active: ((_currentRole$value = currentRole.value) === null || _currentRole$value === void 0 ? void 0 : _currentRole$value.id) === role.id
            }]),
            onClick: $event => selectRole(role)
          }, [_createVNode(_unref(LockOutlined)), _createElementVNode("span", _hoisted_6, _toDisplayString(role.roleName), 1)], 10, _hoisted_5);
        }), 128)), roleList.value.length === 0 ? (_openBlock(), _createBlock(_component_a_empty, {
          key: 0,
          description: "暂无角色数据"
        })) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["spinning"])])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", _hoisted_10, [isEditMode.value ? (_openBlock(), _createBlock(_component_a_button, {
        key: 0,
        onClick: cancelEdit
      }, {
        default: _withCtx(() => [_createTextVNode("取消")]),
        _: 1
      })) : _createCommentVNode("", true), isEditMode.value ? (_openBlock(), _createBlock(_component_a_button, {
        key: 1,
        type: "primary",
        onClick: savePermissions,
        loading: savingLoading.value
      }, {
        default: _withCtx(() => [_createTextVNode("保存")]),
        _: 1
      }, 8, ["loading"])) : (_openBlock(), _createBlock(_component_a_button, {
        key: 2,
        type: "primary",
        onClick: enterEditMode
      }, {
        default: _withCtx(() => [_createTextVNode("编辑")]),
        _: 1
      }))])]), currentRole.value ? (_openBlock(), _createElementBlock("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(permissionGroups.value, group => {
        return _openBlock(), _createElementBlock("div", {
          class: "permission-group",
          key: group.key
        }, [_createElementVNode("div", _hoisted_12, [_createVNode(_component_a_checkbox, {
          indeterminate: isIndeterminate(group.key),
          checked: isGroupChecked(group.key),
          disabled: !isEditMode.value,
          onChange: $event => onGroupCheckChange(group.key, $event)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(group.title), 1)]),
          _: 2
        }, 1032, ["indeterminate", "checked", "disabled", "onChange"])]), _createElementVNode("div", _hoisted_13, [_createVNode(PermissionTree, {
          resources: group.items,
          "selected-permissions": selectedPermissions,
          "is-edit-mode": isEditMode.value,
          onChange: handlePermissionChange,
          onCascadeChange: handleCascadePermissionChange,
          class: "first-level"
        }, null, 8, ["resources", "selected-permissions", "is-edit-mode"])])]);
      }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_14, "请先选择左侧角色"))])]);
    };
  }
});